module.exports = __webpack_public_path__ + "static/media/CeraPro-Light.ad2d037b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/cera/CeraPro-Light.woff2
// module id = 168
// module chunks = 56